import React from 'react';
import LeadQuestionnaire from '../LeadQuestionnaire';
import { coachImages } from '../../data/mock';

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen sm:overflow-hidden">
      {/* Desktop Full-Screen Background Image */}
      <div className="hidden sm:block absolute inset-0">
        <img
          src={coachImages.hero}
          alt="Ramzy - Ramzy Coaching"
          className="w-full h-full object-cover scale-105 object-[center_35%]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/40 to-black/80" />
      </div>

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Top Branding */}
        <div className="bg-black sm:bg-transparent px-3 sm:px-4 pt-4 pb-4 sm:pt-6 sm:pb-0 flex flex-col items-center gap-3" data-testid="hero-navbar">
          <div className="flex flex-col items-center leading-none" data-testid="ramzy-logo">
            <span className="text-3xl sm:text-4xl font-black text-white tracking-[0.35em] uppercase pl-[0.35em]">RAMZY</span>
            <span className="text-[10px] sm:text-xs text-white/70 tracking-[0.45em] uppercase mt-1 pl-[0.45em]">Coaching</span>
          </div>
          <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-md border border-white/30 px-4 py-2">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
            <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-widest">Now Accepting Clients</span>
          </div>
        </div>

        {/* Mobile-only Image Block - shows physique clearly, never covered by form */}
        <div className="sm:hidden relative w-full h-[46vh] min-h-[320px]">
          <img
            src={coachImages.hero}
            alt="Ramzy - Ramzy Coaching"
            className="w-full h-full object-cover object-[center_58%]"
            data-testid="hero-mobile-image"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black" />
        </div>

        {/* Main Form Area */}
        <div className="flex-1 flex items-start sm:items-center justify-center bg-black sm:bg-transparent px-3 sm:px-4 pt-2 sm:py-4 pb-2">
          <div className="w-full max-w-md">
            <LeadQuestionnaire />
          </div>
        </div>

        {/* Bottom Reassurance */}
        <div className="bg-black sm:bg-transparent pb-6 sm:pb-6 pt-2 text-center px-4">
          <p className="text-white/50 text-xs sm:text-sm max-w-xs mx-auto leading-relaxed">
            No spam. No pressure.<br className="sm:hidden" /> If we're not a fit, we'll tell you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
